import ManageUser from './ManageUser';

export default ManageUser;
